import { isDev } from '@/utils/tools.js'
export default {
  appname: 'SkyMusic.AI',
  curObjectStorageType : 'OSS', // OSS || COS
  version: '1.0.1',
  localStorageGlobalKey: 'skywork_music_ai',
  curObjectStorageExpirTimeForwardTo : 30*1000 ,//mm
  baseObjectStorageUrl: import.meta.env.VITE_COS_BASE_URL,
  baseAssetsUrl: import.meta.env.VITE_PUBLIC_PATH
}